/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("WebComponentController", ["ValueContainerControllerBase", "ControllerFactory", "WidgetFactory"], function (context, cls) {
  /**
   * @class WebComponentController
   * @memberOf classes
   * @extends classes.ValueContainerControllerBase
   */
  class WebComponentController extends cls.ValueContainerControllerBase /** @lends classes.WebComponentController.prototype */ {
    static __name = "WebComponentController";

    _properties = null;
    _bufferPending = false;
    _ordersManagedHandler = null;

    /**
     * Initialize behaviors of the controller
     * @private
     */
    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      if (this.isInTable()) {
        this._addBehavior(cls.TableSizeVMBehavior);
      }
      if (!this.isInTable() || this.isInFirstTableRow()) {
        this._addBehavior(cls.LayoutInfoVMBehavior);
      }
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // pseudo-selector behaviors
      this._addBehavior(cls.ActivePseudoSelectorBehavior);
      this._addBehavior(cls.DialogTypePseudoSelectorBehavior);
      if (this.isInMatrix()) {
        this._addBehavior(cls.MatrixCurrentRowVMBehavior);
      }
      this._addBehavior(cls.FontStyle4STBehavior);
      this._addBehavior(cls.FontSize4STBehavior);
      this._addBehavior(cls.FontColor4STBehavior);
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.PropertyVMBehavior);
      this._addBehavior(cls.ComponentTypeVMBehavior);
      this._addBehavior(cls.ValuePrefixedVMBehavior);
      this._addBehavior(cls.EnabledVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
      this._addBehavior(cls.WebComponentStateChangedVMBehavior);
      this._addBehavior(cls.WebComponentCursorsVMBehavior);
      this._addBehavior(cls.StretchVMBehavior);

      // ui behaviors
      this._addBehavior(cls.ValueChangedUIBehavior);
      this._addBehavior(cls.RequestFocusUIBehavior);
      this._addBehavior(cls.OnActionUIBehavior);
      this._addBehavior(cls.OnDataUIBehavior);
      this._addBehavior(cls.HasWebComponentUIBehavior);
      this._addBehavior(cls.WebComponentKeyboardUIBehavior);
    }

    /**
     * @inheritDoc
     */
    constructor(bindings) {
      super(bindings);
      const app = this.getAnchorNode().getApplication();

      // Webcomponent cannot be in a table!
      if (this.isInTable()) {
        app.fail("Cannot initialize table including web component");
      }

      // Once an order is managed, flush the property buffer
      if (app && app.dvm) {
        this._ordersManagedHandler = app.dvm.onOrdersManaged(
          function () {
            if (this._bufferPending && this.getWidget()) {
              this.getWidget().setProperty(JSON.stringify(this._properties));
              this._bufferPending = false;
            }
          }.bind(this)
        );
      }
    }

    /**
     * Bufferize to unsure all properties are sent after a single order
     * @param {Object} properties - JSON object containing the webcomponent properties
     */
    bufferizeProperties(properties) {
      this._bufferPending = true;
      this._properties = Object.assign(this._properties || {}, properties);
    }

    /**
     * @inheritDoc
     */
    destroy() {
      if (this._ordersManagedHandler) {
        this._ordersManagedHandler();
      }
      super.destroy();
    }
  }

  cls.WebComponentController = WebComponentController;
  cls.ControllerFactory.register("WebComponent", cls.WebComponentController);
});
